import axios from "axios";
import AuthService from "./AuthService";

class LocalService{
    authService = null;
    systemService = null;

    constructor() {
        this.authService = new AuthService();
    }

    getWeightFromScale(){
        let user = this.authService.getUser();
        let config = this.authService.getConfig();
        let scaleIp = config.whCode === '4' ? '10.0.1.121' : (config.whCode === '29' ? '10.0.2.107' : (config.whCode ==='79' ? '10.0.8.170' : (config.whCode === '5' ? '10.0.4.110' : '10.0.9.106')));
        let weightPromise = new Promise((resolve, reject) => {
            axios.get(`http://${scaleIp}:3000`, {
                timeout: 4000
            }).then(r => resolve(r.data.weight)).catch(e => reject(e.message));
        });
        return weightPromise;
        
    }

    getVehicles(){
        let config = this.authService.getConfig();
        let cameraIp = config.whCode === '4' ? '10.0.1.121' : (config.whCode === '29' ? '10.0.2.107' : (config.whCode ==='79' ? '10.0.8.170' : (config.whCode === '5' ? '10.0.4.110' : '10.0.9.106')));
        let vehiclesPromise = new Promise((resolve, reject) => {
            axios.post(`http://${cameraIp}:3001/plates`).then(r => {
                resolve(r.data);
            }).catch(e => {
                resolve([]);
            });
        });
        return vehiclesPromise;
    }

    getLatestPlate(){
        let config = this.authService.getConfig();
        let cameraIp = config.whCode === '4' ? '10.0.1.121' : (config.whCode === '29' ? '10.0.2.107' : (config.whCode ==='79' ? '10.0.8.170' : (config.whCode === '5' ? '10.0.4.110' : '10.0.9.106')));
        let vehiclesPromise = new Promise((resolve, reject) => {
            axios.get(`http://${cameraIp}:3000/plates`).then(r => {
                resolve(r.data.lastPlate);
            }).catch(e => {
                resolve('');
            });
        });
        return vehiclesPromise;
    }
}

export default LocalService;